module.exports = __webpack_public_path__ + "img/139.d386cb30.jpg";